import { createContext, ReactNode, useState } from 'react';
import { api } from '../server/api';
import { useAuth } from '../hooks/useAuth';
import { toast } from 'react-toastify';

interface StatementTransaction {
  transactionId: string;
  type: string;
  value: number;
  transactionDate: string;
  pointsOrigin: string;
  redeemMethod?: string;
  vgv?: number;
  metadata?: Record<string, any>;
}

interface StatementTotalValues {
  input: string;
  output: string;
}

interface StatementContextProps {
  listExtract: StatementTransaction[];
  totalValues: StatementTotalValues;
  loading: boolean;
  isVisibleButtonViewMore: boolean;
  actualPage: number;
  setActualPage: (page: number) => void;
  getListExtract: (page: number) => Promise<void>;
}

interface StatementContextProviderProps {
  children: ReactNode;
}

export const statementContext = createContext({} as StatementContextProps);

export function StatementContextProvider(props: StatementContextProviderProps) {
  const { player } = useAuth();
  const [listExtract, setListExtract] = useState<StatementTransaction[]>([]);
  const [totalValues, setTotalValues] = useState<StatementTotalValues>({
    input: '0',
    output: '0',
  });
  const [loading, setLoading] = useState(false);
  const [isVisibleButtonViewMore, setIsVisibleButtonViewMore] = useState(true);
  const [actualPage, setActualPage] = useState(1);

  const getListExtract = async (page: number) => {
    try {
      setLoading(true);
      const response = await api.get(
        `/statement/${player?.id}?currentPage=${page}`
      );

      if (!response.data.body.error) {
        toast.success('Extrato obtido com sucesso.');
        setListExtract(response.data.body.statementTransactions);

        if (response.data.body.totalTransactionsValues) {
          setTotalValues({
            input: response.data.body.totalTransactionsValues.input,
            output: response.data.body.totalTransactionsValues.output,
          });
        }

        const { currentPage, totalPages } = response.data.body.pagination;
        if (currentPage === totalPages) {
          setIsVisibleButtonViewMore(false);
        }
      } else {
        toast.error('Não foi possível buscar o extrato.');
      }
    } catch (error) {
      console.log('getListExtract error: ', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <statementContext.Provider
      value={{
        listExtract,
        totalValues,
        loading,
        isVisibleButtonViewMore,
        actualPage,
        setActualPage,
        getListExtract,
      }}
    >
      {props.children}
    </statementContext.Provider>
  );
}
